import axios from "axios";
import { API } from "../config";

export const deletePost = async (id, password) => {
  return axios
    .delete(API.CUSTOMER_POST + `/user/${id}?password=${password}`)
    .then()
    .catch((ex) => {
      if (ex.response.status === 401) {
        window.location.href = `/admin/login`;
        alert("접근권한이 없습니다.");
      } else {
        alert("서버에 이상이 있습니다. 관리자에게 문의주세요");
      }
    });
};

export const matchPassword = async (id, password) => {
  return axios.get(
    API.CUSTOMER_POST + `/matchPassword/${id}?password=${password}`
  );
};

export const getDetailForCustomer = async (id) => {
  return axios.get(API.CUSTOMER_POST + `/detail/${id}`);
};

export const getIsSecret = async (id) => {
  return axios.get(API.CUSTOMER_POST + `/entireDetail/${id}`);
};

export const editPost = async (id, formData, file, type) => {
  var fileData = new FormData();
  if (file !== null) {
    fileData.append("file", file);
  }

  axios
    .put(
      API.CUSTOMER_POST +
        `/${id}?publisher=${formData.publisher}&password=${formData.password}&email=${formData.email}&title=${formData.title}&isSecret=${formData.isSecret}&content=${formData.content}`,
      fileData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    )
    .then()
    .catch((ex) => {
      if (ex.response.status === 401) {
        window.location.href = `/admin/login`;
        alert("접근권한이 없습니다.");
      } else {
        alert("서버에 이상이 있습니다. 관리자에게 문의주세요");
      }
    });
};

export const postInformation = async (data, file, type) => {
  var fileData = new FormData();
  if (file !== null) {
    fileData.append("file", file);
  }
  return axios
    .post(
      API.CUSTOMER_POST +
        `?publisher=${data.publisher}&password=${data.password}&email=${data.email}&title=${data.title}&isSecret=${data.isSecret}&content=${data.content}&type=${type}`,
      fileData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    )
    .then()
    .catch((ex) => {
      if (ex.response.status === 401) {
        window.location.href = `/admin/login`;
        alert("접근권한이 없습니다.");
      } else {
        alert("서버에 이상이 있습니다. 관리자에게 문의주세요");
      }
    });
};

export const getPostList = async (page, type) => {
  return axios.get(
    API.CUSTOMER_POST + `List?page=${page}&size=10&type=${type}`
  );
};

export const getPostPageCount = async (type) => {
  return axios.get(API.CUSTOMER_POST + `/pageCount?type=${type}`);
};

export const getDetailByPublisher = async (id, password) => {
  return axios.get(
    API.CUSTOMER_POST + `/detailByPublisher/${id}?password=${password}`
  );
};

/// admin

export const deletePostByAdmin = async (id) => {
  axios
    .delete(API.CUSTOMER_POST + `/admin/${id}`)
    .then()
    .catch((ex) => {
      if (ex.response.status === 401) {
        window.location.href = `/admin/login`;
        alert("접근권한이 없습니다.");
      } else {
        alert("서버에 이상이 있습니다. 관리자에게 문의주세요");
      }
    });
};

export const getEntireDetail = async (id) => {
  return axios.get(API.CUSTOMER_POST + `/entireDetail/${id}`);
};

export const postByAdmin = async (data, file, type) => {
  var fileData = new FormData();
  if (file !== null) {
    fileData.append("file", file);
  }

  return axios
    .post(
      API.CUSTOMER_POST +
        `/admin?publisher=${data.publisher}&title=${data.title}&content=${data.content}&type=${type}`,
      fileData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    )
    .then()
    .catch((ex) => {
      if (ex.response.status === 401) {
        window.location.href = `/admin/login`;
        alert("접근권한이 없습니다.");
      } else {
        alert("서버에 이상이 있습니다. 관리자에게 문의주세요");
      }
    });
};

export const editByAdmin = async (id, data, file) => {
  var fileData = new FormData();
  if (file !== null) {
    fileData.append("file", file);
  }

  axios
    .put(
      API.CUSTOMER_POST +
        `/admin/${id}?$puiblisher=${data.publisher}&title=${data.title}&content=${data.content}`,
      fileData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    )
    .then()
    .catch((ex) => {
      if (ex.response.status === 401) {
        window.location.href = `/admin/login`;
        alert("접근권한이 없습니다.");
      } else {
        alert("서버에 이상이 있습니다. 관리자에게 문의주세요");
      }
    });
};

export const getAdminPost = async (page, type) => {
  return axios.get(
    API.CUSTOMER_POST + `/admin?page=${page}&size=10&type=${type}`
  );
};
